import React from "react";
import { Field, FormSpy } from "react-final-form";
import { Checkbox } from "../../../../components/inputs/final_form/Checkbox";
import { LoadingButton } from "../../../../components/LoadingButton";
import { AdministrateSelectInput, AdminOptionableInput } from "../../../components/inputs/AdministrateSelectInput";
import { PayorSelector } from "../../../../components/inputs/final_form/PayorSelector";

export function validateSeeqerReflexMapping(values) {
  const errors = {};

  const hasLab = values?.labId != null && values.labId !== "";
  const hasClinic = values?.clinicId != null && values.clinicId !== "";

  if (!hasLab && !hasClinic) {
    errors.labId = "Select a lab or a clinic";
    errors.clinicId = "Select a lab or a clinic";
  }

  if (hasLab && hasClinic) {
    errors.labId = "Select either a lab or a clinic (not both)";
    errors.clinicId = "Select either a lab or a clinic (not both)";
  }

  return errors;
}

export const SeeqerReflexMappingForm = ({ handleSubmit, submitting, initialTestOptions = [] }) => {
  return (
    <>
      <Field component={AdminOptionableInput} resource="labs" label="Lab" kept={true} name="labId" />
      <Field component={AdminOptionableInput} resource="clinics" label="Clinic" kept={true} name="clinicId" />
      <Field id="allPayors" component={Checkbox} label="All Payors" name="allPayors" type="checkbox" />
      <Field name="allPayors" subscription={{ value: true }}>
        {({ input: { value } }) => !value && <Field render={PayorSelector} label="Payors" name="payorId" />}
      </Field>
      <FormSpy subscription={{ values: true }}>
        {({ values }) => {
          const hasLabOrClinic = values.labId || values.clinicId;

          const buildResourceUrl = () => {
            const baseParams = "test[direction]=asc&test[order]=commercial_name&archived=false";

            if (values.labId) {
              return `/admin/tests.json?${baseParams}&lab=${values.labId}`;
            } else if (values.clinicId) {
              return `/admin/tests.json?${baseParams}&central_repository=true&clinic_id=${values.clinicId}`;
            }

            return `/admin/tests.json?${baseParams}`;
          };

          return (
            <>
              <Field id="allTests" component={Checkbox} label="All Tests" name="allTests" type="checkbox" disabled={!hasLabOrClinic} />
              <Field name="allTests" subscription={{ value: true }}>
                {({ input: { value } }) =>
                  !value && (
                    <Field
                      component={AdministrateSelectInput}
                      resourceUrl={buildResourceUrl()}
                      label="Tests"
                      labelKey="commercial_name"
                      name="testIds"
                      initialOptions={initialTestOptions}
                      isMulti
                      valueKey="id"
                      isDisabled={!hasLabOrClinic}
                      key={`tests-${hasLabOrClinic ? "enabled" : "disabled"}-${values.labId || values.clinicId || "none"}`}
                    />
                  )
                }
              </Field>
            </>
          );
        }}
      </FormSpy>

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
